import { useMachine } from "@xstate/react";
import { useMemo } from "react";
import {
  FilterWizardEventType
} from "./types.js";
import { createFilterWizardMachine } from "./createFilterWizardMachine.js";
const useFilterWizard = ({
  questions,
  onEvent
}) => {
  const machine = useMemo(
    () => createFilterWizardMachine({ questions, onEvent }),
    [questions, onEvent]
  );
  const [state, send] = useMachine(machine);
  const { context } = state;
  const currentStep = context.questionPath.length + 1;
  const progress = Math.round(currentStep / context.totalSteps * 100);
  return {
    active: state.value === "ACTIVE",
    canGoBack: context.questionPath.length > 0,
    canGoNext: Boolean(context.currentQuestion),
    canReset: state.value === "ACTIVE",
    completed: state.value === "COMPLETED",
    currentQuestion: context.currentQuestion,
    currentStep,
    exited: state.value === "EXITED",
    isLastStep: currentStep === context.totalSteps,
    progress,
    totalSteps: context.totalSteps,
    handleAnswer: (answer) => {
      send({ type: FilterWizardEventType.Next, answer });
    },
    handleBack: () => {
      send({ type: FilterWizardEventType.Back });
    },
    handleExit: () => {
      send({ type: FilterWizardEventType.Exit });
    },
    handleReset: () => {
      send({ type: FilterWizardEventType.Reset });
    }
  };
};
export {
  useFilterWizard
};
